import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// PATCH 36 Me3 — breadcrumbs on every nested screen so a user/admin always knows where they are.
// Pass an explicit `trail` for sub-pages that a raw URL can't describe; otherwise it derives one.
const LABELS = {
  workspace: "Workspace", admin: "Admin", governance: "Catalogue & Data Governance",
  "command-center": "Command Center", billing: "Billing", marketplace: "Marketplace",
  hosting: "Hosting", hiring: "Hire", project: "Project", legal: "Legal & Trust",
  features: "Features",
};
const HOME = { label: "Home", to: "/workspace" };

function deriveTrail(pathname) {
  const segs = pathname.split("/").filter(Boolean);
  const trail = [];
  let acc = "";
  segs.forEach((s) => {
    acc += `/${s}`;
    const label = LABELS[s] || (/^[a-f0-9-]{8,}$/i.test(s) ? "Detail" : s.charAt(0).toUpperCase() + s.slice(1));
    trail.push({ label, to: acc });
  });
  return trail;
}

export default function Breadcrumbs({ trail, testid = "breadcrumbs" }) {
  const loc = useLocation();
  const items = trail || deriveTrail(loc.pathname);
  if (!items.length) return null;
  const full = [HOME, ...items];
  return (
    <nav data-testid={testid} aria-label="Breadcrumb"
      style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 4, marginBottom: 14, fontSize: 12 }}>
      {full.map((c, i) => {
        const last = i === full.length - 1;
        return (
          <span key={c.to + i} style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
            {i > 0 && <ChevronRight size={12} className="k-muted" aria-hidden="true" />}
            {last || !c.to
              ? <span className="k-heading" aria-current="page" style={{ fontWeight: 600 }}>{c.label}</span>
              : <Link className="k-link k-muted" to={c.to} data-testid={`crumb-${i}`}>{c.label}</Link>}
          </span>
        );
      })}
    </nav>
  );
}
